import React from 'react'
import {
  Box,
  TextField,
  Typography,
  IconButton,
  Tooltip
} from '@mui/material'
import { Clear } from '@mui/icons-material'

interface EndDateRangeFilterProps {
  startDate: string
  endDate: string
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
  onClear: () => void
}

const EndDateRangeFilter: React.FC<EndDateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear
}) => {
  return (
    <Box sx={{
      minWidth: 180, // Match other filters
      height: '40px',
      display: 'flex',
      alignItems: 'baseline', // Use baseline alignment like other filters
      position: 'relative',
      gap: 0.5,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      p: 0.5
    }}>
      <Typography variant="caption" sx={{
        fontSize: '0.65rem',
        color: 'text.secondary',
        minWidth: 'fit-content',
        fontWeight: 500
      }}>
        End Date:
      </Typography>
      
      <TextField
        type="date"
        size="small"
        value={startDate}
        onChange={(e) => onStartDateChange(e.target.value)}
        sx={{
          minWidth: 85, // Further reduced to fit within 180px total width
          '& .MuiInputBase-input': {
            fontSize: '0.7rem',
            py: 0.25
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.65rem'
          }
        }}
        InputLabelProps={{
          shrink: true,
        }}
        placeholder="Start Date"
      />

      <Typography variant="caption" sx={{ color: 'text.secondary', mx: 0.125, fontSize: '0.65rem' }}>
        to
      </Typography>

      <TextField
        type="date"
        size="small"
        value={endDate}
        onChange={(e) => onEndDateChange(e.target.value)}
        sx={{
          minWidth: 85, // Further reduced to fit within 180px total width
          '& .MuiInputBase-input': {
            fontSize: '0.7rem',
            py: 0.25
          },
          '& .MuiInputLabel-root': {
            fontSize: '0.65rem'
          }
        }}
        InputLabelProps={{
          shrink: true,
        }}
        placeholder="End Date"
      />
      
      {(startDate || endDate) && (
        <Tooltip title="Clear date range">
          <IconButton
            size="small"
            onClick={onClear}
            sx={{ 
              ml: 0.5,
              color: 'text.secondary',
              '&:hover': {
                color: 'error.main'
              }
            }}
          >
            <Clear fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  )
}

export default EndDateRangeFilter
